import { observable } from "mobx";

export default class DecimalRangeRequest {
  @observable
  from?: number;

  @observable
  to?: number;
}
